<template>
  <p v-html="displayedText"></p>
</template>

<script>
export default {
  name: 'animated-text',
  props: ['text'],
  data () {
    return {
      displayedText: '',
      typingSpeed: 45
    }
  },
  mounted: function () {
    this.updateText()
  },
  methods: {
    updateText () {
      if (this.displayedText.length < this.text.length) {
        this.displayedText += this.text.charAt(this.displayedText.length)
        setTimeout(() => this.updateText(), this.typingSpeed)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/parts/utils/AnimatedText.vue